import type { I18nProvider } from '@refinedev/core';
import { AxiosError } from 'axios';

export type ErrorReponseType = {
  code: string;
  detail: string;
  instance: string;
  status: number;
  title: string;
  traceId: string;
};

export const getErrorMessage = (
  i18nProvider: I18nProvider,
  error?: AxiosError<ErrorReponseType>,
): string => {
  const errorCodesPrefix = 'errorCodes';
  const genericError = i18nProvider.translate(`${errorCodesPrefix}.Generic`);
  const errorData = (error as AxiosError<ErrorReponseType>).response?.data;
  const message = errorData
    ? i18nProvider.translate(`${errorCodesPrefix}.${errorData?.code || 'Generic'}`)
    : genericError;

  //if the message includes errorCodes prefix this means that the translation was not found and we want to show the generic message
  return !message.includes(errorCodesPrefix) ? message : genericError;
};
